export const setAccessToken = (tokenData: string): void => {
  sessionStorage.setItem("auth-token", tokenData);
};
